/**
 * @param {import('axios').AxiosInstance} aemAxiosIntance
 */
function config(aemAxiosIntance) {
  function getConfig(platform) {
    return aemAxiosIntance.get("/".concat(platform));
  }
  return {
    getConfig: getConfig
  };
}

export { config as default };
//# sourceMappingURL=config.js.map
